import { z } from 'zod'
import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { useWhitelabelContext } from '@/app/contexts/whitelabelContext'

const formatPhone = (value: string) =>
  value
    .replace(/\D/g, '')
    .replace(/(\d{2})(\d)/, '($1) $2')
    .replace(/(\d{5})(\d)/, '$1-$2')
    .replace(/(-\d{4})\d+?$/, '$1')

const ContactFormSchema = z.object({
  name: z.string().min(1, 'Nome é obrigatório'),
  email: z.string().min(1, 'E-mail é obrigatório').email('E-mail inválido'),
  phone: z
    .string()
    .min(10, 'Telefone é obrigatório')
    .max(15, 'Número inválido')
    .transform((v) => v.replace(/\D/g, '')),
  title: z.string().min(1, 'Motivo é obrigatório'),
  message: z.string().min(1, 'A descrição é obrigatória'),
})

type ContactFormData = z.infer<typeof ContactFormSchema>

export const useContactController = () => {
  const { appConfig} = useWhitelabelContext();

  const methods = useForm<ContactFormData>({
    resolver: zodResolver(ContactFormSchema),
  })

  const {
    formState: { errors },
  } = methods

  const cards = [
    {
      title: 'E-mail',
      subtitle:
        'Tem alguma pergunta? Nossa equipe está pronta para te atender via e-mail.',
      value: appConfig?.supportEmail,
      href: `mailto:${appConfig?.supportEmail}`,
    },
    {
      title: 'Telefone',
      subtitle:
        'Entre em contato com nossa equipe. Estamos sempre prontos para te ajudar.',
      value: formatPhone(appConfig?.supportPhone ?? ''),
      href: `tel:${appConfig?.supportPhone.replace(/\D/g, '')}`,
    },
    {
      title: 'whatsapp',
      subtitle:
        'Precisa de assistência imediata? Fale com nossa equipe pelo WhatsApp.',
      value: formatPhone(appConfig?.supportPhone ?? ''),
      href: `https://wa.me/55${(appConfig?.supportPhone ?? '').replace(/\D/g, '').slice(-11)}`,
    },
  ]

  const onSubmit = methods.handleSubmit((d) => console.log(d))

  return { methods, errors, cards, onSubmit }
}
